import { render, staticRenderFns } from "./DataTemplateDialog.vue?vue&type=template&id=04caf83a&scoped=true&"
import script from "./DataTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./DataTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./DataTemplateDialog.vue?vue&type=style&index=0&id=04caf83a&lang=scss&scoped=true&"
import style1 from "./DataTemplateDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04caf83a",
  null
  
)

export default component.exports